(function() {
'use strict';

angular
    .module('insurance')
    .service('insuranceService', insuranceService);


function insuranceService($http,
                          $browser,
                          tripService,
                          $filter,
                          resourceService,
                          analytics,
                          searchUnitService,
                          occupancyService,
                          $q,
                          insuranceSearchValidator,
                          broker,
                          $cacheFactory,
                          loggingService) {
    const domain = TRPCONFIG.Domain;
    const service = {
        getInsuranceQuotes,
        getInsuranceQuotesFromSession,
        getDocumentPaths,
        passengerInsuranceBand,
        composeOptionId,
        decomposeOptionId,
        clearSearchResults,
        validateSearchCriteria,
        search,
        getSearchResults,
        getInsuranceDetails,
        rehydrate,
        isVatMessageInclusive
        };
    let results;
    let inProgress;
    const url = '/api2/insurance/availability/';
    const detailsUrl = '/api2/insurance/details/';
    let timeout;
    const promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');

    function _doRequest(r, tripId, newSearch) {
        return newSearch ?
            getInsuranceQuotes(tripId, r) :
            getInsuranceQuotesFromSession(r.AvailabilitySearchId);
    }

    function passengerInsuranceBand(insuranceBands, bandId, costOnly) {
        if (!bandId) {
            return costOnly ?
                '-'
                : String.format('{0} ({1}: -)', resourceService.get('INSURANCENOTREQUIRED'), resourceService.get('INSURANCECOST'));
        }

        const option = _.find(insuranceBands, { Id: bandId });

        let priceString = $filter('customCurrency')(option.Price);

        if (!option.Available) {
            priceString = resourceService.get('INSURANCECOSTNA');
        }

        return costOnly ?
            priceString
            : String.format('{0} ({1}: {2})', option.Label, resourceService.get('INSURANCECOST'), priceString);
    }

    function validateSearchCriteria() {
        return insuranceSearchValidator.validate(
            searchUnitService.getPolicyType(),
            searchUnitService.getTravelDestination(),
            searchUnitService.startDate(searchUnitService.insurance),
            searchUnitService.endDate(searchUnitService.insurance),
            occupancyService.reduceOccupancy());
    }

    function search(args) {
        if (inProgress != null && !args.newSearch) {
            return inProgress;
        }
        const tripId = args.tripId;
        let request = {
            AvailabilitySearchId: args.searchId,
            TripId: tripId
        };
        if (args.newSearch) {
            //request for standalone insurance search
            request.SearchType = 1;
            request.TripType = searchUnitService.getPolicyType();
            request.TravelDestination = searchUnitService.getTravelDestination();
            request.StartDate = searchUnitService.startDate(searchUnitService.insurance);
            request.EndDate = searchUnitService.endDate(searchUnitService.insurance);
            request.PolicyExtras = searchUnitService.getPolicyExtra();
        }
        inProgress = tripService.getTripReducedOccupancy(tripId).then(o => {
            o = o || occupancyService.reduceOccupancy();
            const ages = _.concat(o.AdultAges ? o.AdultAges : _.times(o.Adults, () => 21), o.ChildAges);
            request.Ages = ages;
            return _doRequest(request, tripId, args.newSearch).then(function(res) {
                inProgress = null;
                results = res;
                return results;
            }, function() {
                inProgress = null;
                results = null;
            });
        });
        return inProgress;
    }

    function getInsuranceQuotes(tripId, request) {
        const req = angular.extend({
            DomainId: domain.DomainId,
            Currency: domain.CurrencyCode,
            CultureCode: domain.CultureCode
        }, request);
        tripService.recordInsuranceSearch(tripId, request);
        analytics.startTimer('InsuranceAvailabilityRequest');
        return $http.post(`${url}get`, req, { ignoreErrors: true }).then(function(res) {
            analytics.endTimer('InsuranceAvailabilityRequest');
            return enrichData(res.data.Quotes);
        });
    }

    function getInsuranceQuotesFromSession(availabilitySearchId) {
        return $http.post(`${url}getfromsession`, {
            AvailabilitySearchId: availabilitySearchId
        }, { ignoreErrors: true }).then(function(res) {
            return enrichData(res.data.Quotes);
        });
    }

    function getDocumentPaths() {
        //these paths should probably be coming back from the service call really and
        //the docs be served from the service ideally.
        const baseRoute = `${$browser.baseHref()}build/docs/BookingConditions/`;
        return {
            PolicyWording: `${baseRoute}${TRPCONFIG.Domain.InsurancePolicyWordingDoc}`,
            SilverPolicyWording: `${baseRoute}${TRPCONFIG.Domain2.InsuranceSilverPolicyWordingDoc}`,
            Disclosure: `${baseRoute}${TRPCONFIG.Domain.StatusDisclosureDoc}`,
            PolicySummary: `${baseRoute}${TRPCONFIG.Domain.InsuranceKeyFactsDoc}`,
            InsuranceProductInformation: TRPCONFIG.Domain.InsuranceProductInformation ?
                `${baseRoute}${TRPCONFIG.Domain.InsuranceProductInformation}` : '',
        };
    }

    function enrichData(quotes) {
        if (TRPCONFIG.Domain.InsurancePerPersonPricing === false) {
            return quotes;
        }

        angular.forEach(quotes, function(quote) {
            quote.PerPersonPrice = quote.Price / (quote.AdultCount + quote.ChildCount + quote.InfantCount);
        });
        return quotes;
    }

    function composeOptionId(schemeId, typeId, supplierId) {
        return `${schemeId}|${typeId}|${supplierId}`;
    }

    function decomposeOptionId(id) {
        //takes a key like 1|1|208 and returns a correctly set object
        const parts = id.split('|');
        let obj = {
            schemeId: parseInt(parts[0]),
            typeId: parseInt(parts[1]),
            supplierId: parseInt(parts[2])
        };
        if (parts[3]) {
            obj.relationshipId = parseInt(parts[3]);
        } else {
            loggingService.logWarn(`RelationshipId - insurance.service.js, decomposeOptionId() warn ${id}`);
        }
        return obj;
    }

    function clearSearchResults() {
        results = null;
    }

    function getSearchResults(searchId, tripId) {
        if (results && results !== 'null') {
            return $q.when(_.cloneDeep(results));
        }
        return search({ searchId, tripId });
    }

    function getInsuranceDetails(params) {
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        return $http.get(`${detailsUrl}get`, {
            timeout: timeout.promise,
            params: {
                availabilityId: params.AvailabilityId,
                schemeId: params.SchemeId,
                tripTypeId: params.TripTypeId,
                supplierId: params.SupplierId,
                destinationId: params.DestinationId,
                relationshipId: params.RelationshipId
            },
            customErrCallback(args) {
                if (args.status) {
                    broker.publish('insuranceRequestFailed');
                }
                return true;
            }
        }).then(function(res) {
            promiseCache.remove(res.data.DetailSearchId);
            timeout = null;
            return res.data;
        });
    }

    function rehydrate(id) {
        if (!promiseCache.get(id)) {
            promiseCache.put(id, $http.post(`${detailsUrl}getfromsession?detailSearchId=${id}`, { ignoreErrors: true }).then(function(res) {
                return res.data;
            }));
        }
        return promiseCache.get(id);
    }

    function isVatMessageInclusive(insuranceQuotes, isMultiple) {
        if (!isMultiple && (insuranceQuotes && insuranceQuotes.length === 1)) {
            return true;
        } else if (isMultiple && (insuranceQuotes && insuranceQuotes.length > 1)) {
            return true;
        }
        return false;
    }

    return service;
}
})();
